import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import axios from "axios";
import EmojiPicker, { Emoji } from "@indahash/emoji-picker-react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import { SelectedLabels } from "src/app/components/SelectTags/partials/SelectedLabels/SelectedLabels";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import {
  isValidUrl,
  generateCreatorFromString,
  replaceOldTikTokProviderName,
} from "src/app/modals/AddCreatorsModal/components/GenerateCreatorFromString";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import {
  changeSearchAudienceFilters,
  setIsIncorrectProviderError,
} from "./redux/creatorSearchActions";
import CONSTS from "../../helpers/consts";
import { useOnClickOutside } from "../../base/utils/useOnOutsideClick";
import { countActiveFields } from "../AudiencesSearch/utils/countActiveFields";
import FollowersCountRange from "../AudiencesSearch/partials/FollowersCountRange/FollowersCountRange";
import CriteriaOptionSelector from "../AudiencesSearch/components/filters/CriteriaOptionSelector/CriteriaOptionSelector";
import SearchByUsernameOrLink from "../AudiencesSearch/components/filters/SearchByUsernameOrLink";
import FollowersRange from "../AudiencesSearch/components/filters/FollowersRange";
import InfluencerAgeRangeSelect from "../AudiencesSearch/components/filters/InfluencerAgeRangeSelect";
import InfluencerGenderSelect from "../AudiencesSearch/components/filters/InfluencerGenderSelect";
import InfluencerCountriesTags from "../AudiencesSearch/components/filters/InfluencerCountriesTags";
import getAges from "../AudiencesSearch/components/filters/utils/getAges";
import InfluencerCityInput from "../AudiencesSearch/components/filters/InfluencerCityInput";
import SocialPlatformTags from "../AudiencesSearch/components/filters/SocialPlatform/SocialPlatformTags";
import InfluencerCountryInput from "../AudiencesSearch/components/filters/InfluencerCountryInput";
import AudienceGenderSelect from "../AudiencesSearch/components/filters/AudienceGenderSelect";
import AudienceGenderDensity from "../AudiencesSearch/components/filters/AudienceGenderDensitySelect";
import AudienceInterestsInput from "../AudiencesSearch/components/filters/AudienceInterestsInput";
import AudienceAgeDensitySelect from "../AudiencesSearch/components/filters/AudienceAgeDensitySelect";
import METHODS from "../../helpers/methods";
import socialPlatformOptions from "../AudiencesSearch/components/filters/utils/socialPlatformOptions";
import Accordion from "./components/Accordion/Accordion";
import InfluencerCategory from "./components/InfluencerCategory";
import { CreatorTagsFilter } from "../AudiencesSearch/components/filters/CreatorTagsFilter/CreatorTagsFilter";
import { PillSelector } from "src/app/components/PillSelector/PillSelector";

import "./CreatorSearch.scss";

const influencerSocialProvider = {
  value: "instagram",
};

export default function CreatorSearch({ preSelect, applyFilters, footer }) {
  const [searchTopic, setSearchTopic] = useState("");
  const [chosenTopics, setChosenTopics] = useState([]);
  const foundTopics = useRef({ count: 0, name: null });

  const [chosenUnifiedCategories, setChosenUnifiedCategories] = useState([]);

  const [searchBrand, setSearchBrand] = useState("");
  const [chosenBrands, setChosenBrands] = useState([]);
  const foundBrands = useRef({ count: 0, name: null });

  const [searchKeyword, setSearchKeyword] = useState("");
  const [chosenKeywords, setChosenKeywords] = useState([]);
  const foundKeywords = useRef({ count: 0, name: null });

  const [audienceCredibilityScore, setAudienceCredibilityScore] =
    useState(null);
  const [paidPostPerformanceMin, setPaidPostPerformanceMin] = useState(null);
  const [creatorsAvailableInCrm, setCreatorsAvailableInCrm] = useState(null);
  const [hasContactData, setHasContactData] = useState(false);
  const [excludeCreatorsFromDatabase, setExcludeCreatorsFromDatabase] =
    useState(false);
  const [minimumEr, setMinimumEr] = useState(null);
  const [searchAudienceCountry, setSearchAudienceCountry] = useState("");
  const [selectedAudienceCountries, setSelectedAudienceCountries] = useState(
    [],
  );
  const [searchAudienceLanguage, setSearchAudienceLanguage] = useState("");
  const [selectedAudienceLanguages, setSelectedAudienceLanguages] = useState(
    [],
  );
  const [audienceGender, setAudienceGender] = useState(null);
  const [audienceGenderDensity, setAudienceGenderDensity] = useState(null);
  const [audienceAgeFrom, setAudienceAgeFrom] = useState(null);
  const [audienceAgeTo, setAudienceAgeTo] = useState(null);
  const [audienceAgeDensity, setAudienceAgeDensity] = useState(null);
  const [influencerSocialUsername, setInfluencerSocialUsername] = useState([]);
  const [influencerGender, setInfluencerGender] = useState(null);
  const [influencerAgeFrom, setInfluencerAgeFrom] = useState(null);
  const [influencerAgeTo, setInfluencerAgeTo] = useState(null);
  const [selectedInfluencerCountries, setSelectedInfluencerCountries] =
    useState([]);
  const [influencerFollowers, setInfluencerFollowers] = useState([]);

  const [disableEffects, setDisableEffects] = useState(true);
  const [disableEffectsId, setDisableEffectsId] = useState(null);
  const [lastPostsWithin, setLastPostsWithin] = useState(null);
  const [searchContents, setSearchContents] = useState([]);
  const [searchHashtags, setSearchHashtags] = useState([]);
  const [searchMentions, setSearchMentions] = useState([]);
  const [searchBioKeywords, setSearchBioKeywords] = useState([]);
  const [contentsOption, setContentsOption] = useState(null);
  const [hashtagsOption, setHashtagsOption] = useState(null);
  const [mentionsOption, setMentionsOption] = useState(null);
  const [socialPlatformOption, setSocialPlatformOption] = useState(null);
  const [searchBioKeywordsOption, setSearchBioKeywordsOption] = useState(null);
  const [aiTagsOption, setAiTagsOption] = useState(null);
  const [audienceInterestsOption, setAudienceInterestsOption] = useState(null);
  const [audienceBrandAffinityOption, setAudienceBrandAffinityOption] =
    useState(null);
  const [searchByContentInputValue, setSearchByContentInputValue] =
    useState("");
  const [hashtagsInputValue, setHashtagsInputValue] = useState("");
  const [mentionsInputValue, setMentionsInputValue] = useState("");
  const [countriesInputValue, setCountriesInputValue] = useState("");
  const [bioInputValue, setBioInputValue] = useState("");
  const [showInfluencerMetrics, setShowInfluencerMetrics] = useState(true);
  const [showSearchByContent, setShowSearchByContent] = useState(false);
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [showAudienceData, setShowAudienceData] = useState(false);
  const [popularHashtags, setPopularHashtags] = useState(null);

  const [citiesInputValue, setCitiesInputValue] = useState("");
  const [influencerCities, setInfluencerCities] = useState([]);
  const [selectedInfluencerCities, setSelectedInfluencerCities] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [bioInputFocused, setBioInputFocused] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [selectedCreatorTags, setSelectedCreatorTags] = useState([]);
  const [creatorTagsMatchType, setCreatorTagsMatchType] = useState(null);

  const hasInitializedSections = useRef(false);

  const [timerId, setTimerId] = useState(null);

  const dispatch = useDispatch();

  const intl = useIntl();

  const influencerMetricsCount = countActiveFields([
    selectedInfluencerCountries.length,
    influencerSocialUsername.length,
    influencerGender,
    influencerAgeFrom,
    influencerAgeTo,
    influencerFollowers.length,
    audienceCredibilityScore,
    paidPostPerformanceMin,
    minimumEr,
    creatorsAvailableInCrm,
    excludeCreatorsFromDatabase,
    hasContactData,
    selectedProviders.length,
    chosenUnifiedCategories.length,
    selectedCreatorTags.length,
  ]);

  const hasInfluencerSocialUsername = influencerSocialUsername.length > 0;

  const contentSearchTagsCount =
    searchContents.length > 0
      ? searchContents.length
      : searchBioKeywords.length +
        searchHashtags.length +
        searchMentions.length +
        chosenKeywords.length;
  const contentSearchCount = countActiveFields([
    lastPostsWithin,
    contentSearchTagsCount,
  ]);

  const audienceDataCount = countActiveFields([
    selectedAudienceCountries.length,
    selectedAudienceLanguages.length,
    audienceGender,
    audienceAgeFrom,
    audienceAgeTo,
    chosenTopics.length,
    chosenBrands.length,
  ]);

  const {
    interests,
    audienceCountries,
    audienceLanguages,
    creatorTags,
    influencerCountriesByProvider,
    audienceBrandAffinity,
    keywords,
    isIncorrectProviderError,
    unifiedCategories,
  } = useSelector((state) => state.creatorSearchReducer);

  const enabledSocialProviders = useMemo(
    () => Object.keys(influencerCountriesByProvider || {}),
    [influencerCountriesByProvider],
  );

  const influencerCountriesForSelectedProviders = useMemo(() => {
    const providers = selectedProviders.length
      ? selectedProviders
      : enabledSocialProviders;

    const countriesByLabel = {};

    providers.forEach((provider) => {
      (influencerCountriesByProvider[provider] ?? []).forEach((country) => {
        countriesByLabel[country.label] = country;
      });
    });

    return Object.values(countriesByLabel);
  }, [influencerCountriesByProvider, selectedProviders, enabledSocialProviders]);

  const hiddenSocialPlatforms = useMemo(
    () =>
      socialPlatformOptions
        .map((option) => option.value)
        .filter((value) => !enabledSocialProviders.includes(value)),
    [enabledSocialProviders],
  );

  const clearFiltersState = () => {
    setSelectedAudienceCountries([]);
    setSelectedAudienceLanguages([]);
    setChosenTopics([]);
    setChosenUnifiedCategories([]);
    setAudienceCredibilityScore(null);
    setPaidPostPerformanceMin(null);
    setMinimumEr(null);
    setCreatorsAvailableInCrm(null);
    setExcludeCreatorsFromDatabase(false);
    setHasContactData(false);
    setAudienceGender(null);
    setAudienceGenderDensity(null);
    setAudienceAgeFrom(null);
    setAudienceAgeTo(null);
    setAudienceAgeDensity(null);
    setInfluencerSocialUsername([]);
    setInfluencerGender(null);
    setInfluencerAgeFrom(null);
    setInfluencerAgeTo(null);
    setSelectedInfluencerCountries([]);
    setSelectedInfluencerCities([]);
    setInfluencerFollowers([]);
    setChosenBrands([]);
    setLastPostsWithin(null);
    setSearchContents([]);
    setSearchHashtags([]);
    setSearchMentions([]);
    setSearchBioKeywords([]);
    setHashtagsOption({ value: "or" });
    setContentsOption({ value: "or" });
    setMentionsOption({ value: "or" });
    setSearchBioKeywordsOption({ value: "or" });
    setAiTagsOption({ value: "or" });
    setAudienceInterestsOption({ value: "or" });
    setAudienceBrandAffinityOption({ value: "or" });
    setSocialPlatformOption({ value: "or" });
    setChosenKeywords([]);
    setAdvancedSearch(false);
    setSelectedProviders([]);
    setSelectedCreatorTags([]);
    setCreatorTagsMatchType({ value: "or" });
  };

  useEffect(() => {
    // There is a little trick for preSelect correct setting state
    // There was a bug => density in preSelect was always set to 10%
    // It happened because of useEffect for age etc., because there was
    // logic to set 10% density when main param is set.
    // But when there is preSelect flow it also was changing density to 10%
    // due to useEffect logic.
    // So there is a workaround to disable useEffect for 1s, to set values
    // correctly. It may cause problems when user will really fast change
    // some fields, but it is really unlikely to happen.
    setDisableEffectsId(
      setTimeout(() => {
        setDisableEffects(false);
        setDisableEffectsId(null);
      }, 1000),
    );

    return () => {
      if (disableEffectsId) {
        clearTimeout(disableEffectsId);
      }
    };
  }, []);

  useEffect(() => {
    if (preSelect) {
      setSelectedAudienceCountries(preSelect.selectedAudienceCountries || []);
      setSelectedAudienceLanguages(
        preSelect.selectedAudienceLanguages || [],
      );
      setChosenTopics(preSelect.chosenTopics || []);
      setChosenUnifiedCategories(preSelect.chosenUnifiedCategories || []);
      setAudienceCredibilityScore(preSelect.audienceCredibilityScore || null);
      setPaidPostPerformanceMin(preSelect.paidPostPerformanceMin || null);
      setMinimumEr(preSelect.minimumEr || null);
      setCreatorsAvailableInCrm(preSelect.creatorsAvailableInCrm || null);
      setExcludeCreatorsFromDatabase(
        preSelect.excludeCreatorsFromDatabase || false,
      );
      setHasContactData(preSelect.hasContactData || false);
      setAudienceGender(preSelect.audienceGender || null);
      setAudienceGenderDensity(preSelect.audienceGenderDensity || null);
      setAudienceAgeFrom(preSelect.audienceAgeFrom || null);
      setAudienceAgeTo(preSelect.audienceAgeTo || null);
      setAudienceAgeDensity(preSelect.audienceAgeDensity || null);
      setInfluencerSocialUsername(preSelect.influencerSocialUsername || []);
      setInfluencerGender(preSelect.influencerGender || null);
      setInfluencerAgeFrom(preSelect.influencerAgeFrom || null);
      setInfluencerAgeTo(preSelect.influencerAgeTo || null);
      setSelectedInfluencerCountries(
        preSelect.selectedInfluencerCountries || [],
      );
      setSelectedInfluencerCities(preSelect.selectedInfluencerCities || []);
      setInfluencerFollowers(preSelect.influencerFollowers || []);
      setChosenBrands(preSelect.chosenBrands || []);
      setLastPostsWithin(preSelect.lastPostsWithin || null);
      setSearchContents(preSelect.searchContents || []);
      setSearchHashtags(preSelect.searchHashtags || []);
      setSearchMentions(preSelect.searchMentions || []);
      setSearchBioKeywords(preSelect.searchBioKeywords || []);
      setHashtagsOption(preSelect.hashtagsOption || { value: "or" });
      setContentsOption(preSelect.contentsOption || { value: "or" });
      setMentionsOption(preSelect.mentionsOption || { value: "or" });
      setSearchBioKeywordsOption(
        preSelect.searchBioKeywordsOption || { value: "or" },
      );
      setAiTagsOption(preSelect.aiTagsOption || { value: "or" });
      setAudienceInterestsOption(
        preSelect.audienceInterestsOption || { value: "or" },
      );
      setAudienceBrandAffinityOption(
        preSelect.audienceBrandAffinityOption || { value: "or" },
      );
      setSocialPlatformOption(
        preSelect.socialPlatformOption || { value: "or" },
      );
      setChosenKeywords(preSelect.chosenKeywords || []);

      if (
        !preSelect.searchContents?.length &&
        (preSelect.searchHashtags?.length ||
          preSelect.searchMentions?.length ||
          preSelect.searchBioKeywords?.length ||
          preSelect.chosenKeywords?.length)
      ) {
        setAdvancedSearch(true);
      }

      if (preSelect?.selectedProviders?.length > 0) {
        setSelectedProviders(preSelect.selectedProviders || []);
      }

      setSelectedCreatorTags(preSelect?.selectedCreatorTags || []);
      setCreatorTagsMatchType(
        preSelect?.creatorTagsMatchType || { value: "or" },
      );
    }
  }, [dispatch, preSelect]);

  const getPopularHashtags = async (value, uniqCountries) => {
    const params = new URLSearchParams({
      searchString: value || "",
      provider: CONSTS.socialProvider.instagram,
      countries:
        uniqCountries || selectedInfluencerCountries.map((el) => el.value),
    }).toString();

    const {
      data: { content: resPopularHashtags },
    } = await axios.get(CONSTS.getPopularHashtags + params);
    setPopularHashtags(resPopularHashtags);
  };

  const filters = useMemo(
    () => ({
      chosenTopics,
      chosenUnifiedCategories,
      chosenBrands,
      audienceCredibilityScore,
      paidPostPerformanceMin,
      minimumEr,
      selectedAudienceCountries,
      selectedAudienceLanguages,
      audienceGender,
      audienceGenderDensity,
      audienceAgeFrom,
      audienceAgeTo,
      audienceAgeDensity,
      influencerSocialUsername,
      influencerGender,
      influencerAgeFrom,
      influencerAgeTo,
      selectedInfluencerCountries,
      selectedInfluencerCities,
      influencerFollowers,
      lastPostsWithin,
      searchContents,
      hashtagsOption,
      socialPlatformOption,
      contentsOption,
      mentionsOption,
      searchBioKeywordsOption,
      aiTagsOption,
      audienceInterestsOption,
      audienceBrandAffinityOption,
      searchHashtags,
      searchMentions,
      searchBioKeywords,
      chosenKeywords,
      creatorsAvailableInCrm,
      excludeCreatorsFromDatabase,
      hasContactData,
      selectedProviders,
      selectedCreatorTags,
      creatorTagsMatchType,
    }),
    [
      chosenTopics,
      chosenUnifiedCategories,
      chosenBrands,
      audienceCredibilityScore,
      paidPostPerformanceMin,
      minimumEr,
      selectedAudienceCountries,
      selectedAudienceLanguages,
      audienceGender,
      audienceGenderDensity,
      audienceAgeFrom,
      audienceAgeTo,
      audienceAgeDensity,
      influencerSocialUsername,
      influencerGender,
      influencerAgeFrom,
      influencerAgeTo,
      selectedInfluencerCountries,
      selectedInfluencerCities,
      influencerFollowers,
      lastPostsWithin,
      searchContents,
      hashtagsOption,
      socialPlatformOption,
      contentsOption,
      mentionsOption,
      searchBioKeywordsOption,
      aiTagsOption,
      audienceInterestsOption,
      audienceBrandAffinityOption,
      searchHashtags,
      searchMentions,
      searchBioKeywords,
      chosenKeywords,
      creatorsAvailableInCrm,
      excludeCreatorsFromDatabase,
      hasContactData,
      selectedProviders,
      selectedCreatorTags,
      creatorTagsMatchType,
    ],
  );

  const handleApplyFilters = () => {
    applyFilters(filters, influencerSocialUsername.length > 0);
  };

  useEffect(() => {
    dispatch(changeSearchAudienceFilters(filters));
  }, [dispatch, filters]);

  useEffect(() => {
    if (!disableEffects) {
      if (audienceGender && !audienceGenderDensity) {
        setAudienceGenderDensity({
          value: `10`,
          label: `10 %`,
        });
      }
      if (!audienceGender && audienceGenderDensity) {
        setAudienceGenderDensity(null);
      }
    }
  }, [audienceGender]);

  useEffect(() => {
    if (!disableEffects) {
      if ((audienceAgeFrom || audienceAgeTo) && !audienceAgeDensity) {
        setAudienceAgeDensity({
          value: `10`,
          label: `10 %`,
        });
      }

      if (!(audienceAgeFrom || audienceAgeTo) && audienceAgeDensity) {
        setAudienceAgeDensity(null);
      }
    }
  }, [audienceAgeFrom, audienceAgeTo]);

  const topicClick = (id) => {
    if (chosenTopics.indexOf(id) > -1) {
      setChosenTopics(chosenTopics.filter((itemId) => itemId !== id));
    } else {
      setChosenTopics([...chosenTopics, id]);
    }

    if (!audienceInterestsOption) {
      setAudienceInterestsOption({ value: "or" });
    }
  };

  const unifiedCategoryClick = (id) => {
    if (chosenUnifiedCategories.indexOf(id) > -1) {
      setChosenUnifiedCategories((prev) =>
        prev.filter((itemId) => itemId !== id),
      );
    } else {
      setChosenUnifiedCategories((prev) => [...prev, id]);
    }
  };

  const brandClick = (name) => {
    if (chosenBrands.indexOf(name) > -1) {
      setChosenBrands(chosenBrands.filter((itemName) => itemName !== name));
    } else {
      setChosenBrands([...chosenBrands, name]);
    }

    if (!audienceBrandAffinityOption) {
      setAudienceBrandAffinityOption({ value: "or" });
    }
  };

  const keywordClick = (id) => {
    if (chosenKeywords.indexOf(id) > -1) {
      setChosenKeywords(chosenKeywords.filter((itemId) => itemId !== id));
    } else {
      setChosenKeywords([...chosenKeywords, id]);
    }

    if (!aiTagsOption) {
      setAiTagsOption({ value: "or" });
    }
  };

  const hashtagClick = (name) => {
    if (searchHashtags.indexOf(name) > -1) {
      setSearchHashtags(searchHashtags.filter((itemName) => itemName !== name));
    } else {
      setSearchHashtags([...searchHashtags, name]);
    }

    if (!hashtagsOption) {
      setHashtagsOption({ value: "or" });
    }
  };

  const contentClick = (name) => {
    if (searchContents.indexOf(name) > -1) {
      setSearchContents(searchContents.filter((itemName) => itemName !== name));
    } else {
      setSearchContents([...searchContents, name]);
    }

    if (!contentsOption) {
      setContentsOption({ value: "or" });
    }
  };

  const mentionClick = (name) => {
    if (searchMentions.indexOf(name) > -1) {
      setSearchMentions(searchMentions.filter((itemName) => itemName !== name));
    } else {
      setSearchMentions([...searchMentions, name]);
    }

    if (!mentionsOption) {
      setMentionsOption({ value: "or" });
    }
  };

  const cityClick = (name) => {
    if (selectedInfluencerCities.indexOf(name) > -1) {
      setSelectedInfluencerCities(
        selectedInfluencerCities.filter((itemName) => itemName !== name),
      );
    } else {
      setSelectedInfluencerCities([...selectedInfluencerCities, name]);
    }
  };

  const audienceCountrySet = (country) => {
    const uniqCountries = [...new Set([...selectedAudienceCountries, country])];
    setSelectedAudienceCountries(uniqCountries);
    setSearchAudienceCountry("");
  };

  const audienceCountryUnset = (label) => {
    const uniqCountries = selectedAudienceCountries.filter(
      (c) => c.label !== label.substring(0, label.length - 4),
    );
    setSelectedAudienceCountries(uniqCountries);
  };

  const audienceLanguageSet = (language) => {
    const uniqLanguages = [
      ...new Set([...selectedAudienceLanguages, language]),
    ];
    setSelectedAudienceLanguages(uniqLanguages);
    setSearchAudienceLanguage("");
  };

  const audienceLanguageUnset = (label) => {
    const uniqLanguages = selectedAudienceLanguages.filter(
      (l) => l.label !== label.substring(0, label.length - 4),
    );
    setSelectedAudienceLanguages(uniqLanguages);
  };

  const matchCountry = (label) => {
    return influencerCountriesForSelectedProviders.find(
      (c) => c.label === label,
    );
  };

  const countrySet = (label) => {
    const newValue = matchCountry(label);
    const uniqCountries = [
      ...new Set([...selectedInfluencerCountries, newValue]),
    ];
    setSelectedInfluencerCountries(uniqCountries);

    getPopularHashtags(
      hashtagsInputValue,
      uniqCountries.map((el) => el.value),
    );
  };

  const countryUnset = (label) => {
    const uniqCountries = selectedInfluencerCountries.filter(
      (c) => c.label !== label,
    );
    setSelectedInfluencerCountries(uniqCountries);

    getPopularHashtags(
      hashtagsInputValue,
      uniqCountries.map((el) => el.value),
    );
  };

  const getLastPostsWithinOptions = () => {
    const numbers = [1, 3, 6];
    return numbers.map((number) => ({
      value: number,
      label: `${number} month${number !== 1 ? "s" : ""}`,
    }));
  };

  const getMinimumErOptions = () => {
    const options = [];
    for (let i = 1; i < 41; i++) {
      options.push({
        value: `${i / 2}`,
        label: `≥ ${i / 2}%`,
      });
    }
    return options;
  };

  const addHashtagOrBio = (e, eventName, labelType) => {
    let value;

    if (labelType === "hashtag") {
      value = hashtagsInputValue.replace(/,\s*$/, "").trim();
    } else if (labelType === "bio") {
      value = bioInputValue.replace(/,\s*$/, "").trim();
    } else if (labelType === "mention") {
      value = mentionsInputValue.replace(/,\s*$/, "").trim();
    } else if (labelType === "content") {
      value = searchByContentInputValue.replace(/,\s*$/, "").trim();
    }

    const bioTriggers =
      (e.key === "Enter" ||
        e.key === " " ||
        e.key === "," ||
        eventName === "blur") &&
      (labelType === "bio" || labelType === "mention");

    const hashtagsTriggers =
      (e.key === "Enter" || e.key === " " || e.key === ",") &&
      labelType === "hashtag";

    const contentTriggers =
      (e.key === "Enter" || e.key === " " || e.key === ",") &&
      labelType === "content";

    if (value.length) {
      if (bioTriggers || hashtagsTriggers || contentTriggers) {
        let pastedArray;
        if (value.indexOf(", ") > -1) {
          pastedArray = value.split(", ");
        } else if (value.indexOf(",") > -1) {
          pastedArray = value.split(",");
        } else if (value.indexOf(" ") > -1) {
          pastedArray = value.split(" ");
        } else {
          pastedArray = [value];
        }

        const connectedArrays =
          labelType === "hashtag"
            ? [...searchHashtags, ...pastedArray]
            : labelType === "bio"
              ? [...searchBioKeywords, ...pastedArray]
              : labelType === "content"
                ? [...searchContents, ...pastedArray]
                : labelType === "mention" && [
                    ...searchMentions,
                    ...pastedArray,
                  ];

        const tagPrefixes = ["#", "@"];

        connectedArrays.forEach((hashtag, index, arr) => {
          arr[index] = tagPrefixes.includes(hashtag.charAt(0))
            ? hashtag.slice(1)
            : hashtag;
        });
        const uniqueLabels = [...new Set(connectedArrays)];

        if (labelType === "hashtag") {
          setSearchHashtags(uniqueLabels);
          setHashtagsInputValue("");
          setPopularHashtags(null);
          setTimerId(setTimeout(() => getPopularHashtags(""), 500));
          if (!hashtagsOption) {
            setHashtagsOption({ value: "or" });
          }
        } else if (labelType === "mention") {
          setSearchMentions(uniqueLabels);
          setMentionsInputValue("");
          if (!mentionsOption) {
            setMentionsOption({ value: "or" });
          }
        } else if (labelType === "bio") {
          setSearchBioKeywords(uniqueLabels);
          setBioInputValue("");
          if (!searchBioKeywordsOption) {
            setSearchBioKeywordsOption({ value: "or" });
          }
        } else if (labelType === "content") {
          setSearchContents(uniqueLabels);
          setSearchByContentInputValue("");
          if (!contentsOption) {
            setContentsOption({ value: "or" });
          }
        }
      }
    }
  };

  const addEmojiToBio = (emoji) => {
    const uniqueLabels = [...new Set([...searchBioKeywords, emoji])];
    setSearchBioKeywords(uniqueLabels);
  };

  const deleteLabel = (indexToDelete, labelType) => {
    if (labelType === "hashtag") {
      const hashtagsArr = [...searchHashtags];
      hashtagsArr.splice(indexToDelete, 1);
      setSearchHashtags(hashtagsArr);
      if (!hashtagsArr.length) {
        setHashtagsOption(null);
      }
    } else if (labelType === "content") {
      const contentsArr = [...searchContents];
      contentsArr.splice(indexToDelete, 1);
      setSearchContents(contentsArr);
      if (!contentsArr.length) {
        setContentsOption(null);
      }
    } else if (labelType === "bio") {
      setSearchBioKeywords(
        searchBioKeywords.filter((b) => b !== indexToDelete),
      );
      if (!searchBioKeywords.length) {
        setSearchBioKeywordsOption(null);
      }
    } else if (labelType === "mention") {
      const searchMentionsArr = [...searchMentions];
      searchMentionsArr.splice(indexToDelete, 1);
      setSearchMentions(searchMentionsArr);
      if (!searchMentionsArr.length) {
        setMentionsOption(null);
      }
    } else if (labelType === "influencer-country") {
      const selectedInfluencerCountriesArr = [...selectedInfluencerCountries];
      selectedInfluencerCountriesArr.splice(indexToDelete, 1);
      getPopularHashtags(
        hashtagsInputValue,
        selectedInfluencerCountriesArr.map((el) => el.value),
      );
      setSelectedInfluencerCountries(selectedInfluencerCountriesArr);
    } else if (labelType === "influencer-city") {
      const selectedInfluencerCitiesArr = [...selectedInfluencerCities];
      selectedInfluencerCitiesArr.splice(indexToDelete, 1);
      setSelectedInfluencerCities(selectedInfluencerCitiesArr);
    } else if (labelType === "audience-country") {
      const selectedAudienceCountriesArr = [...selectedAudienceCountries];
      selectedAudienceCountriesArr.splice(indexToDelete, 1);
      setSelectedAudienceCountries(selectedAudienceCountriesArr);
    } else if (labelType === "audience-language") {
      const selectedAudienceLanguagesArr = [...selectedAudienceLanguages];
      selectedAudienceLanguagesArr.splice(indexToDelete, 1);
      setSelectedAudienceLanguages(selectedAudienceLanguagesArr);
    } else if (labelType === "brand") {
      const brandsArr = [...chosenBrands];
      brandsArr.splice(indexToDelete, 1);
      setChosenBrands(brandsArr);
      if (!brandsArr.length) {
        setAudienceBrandAffinityOption(null);
      }
    } else if (labelType === "keyword") {
      const keywordsArr = [...chosenKeywords];
      keywordsArr.splice(indexToDelete, 1);
      setChosenKeywords(keywordsArr);
      if (!keywordsArr.length) {
        setAiTagsOption(null);
      }
    }
  };

  const handleEnterPress = (e, listType) => {
    if (e.key === "Enter") {
      if (listType === "keywords" && foundKeywords.current.count === 1) {
        foundKeywords.current.count = 0;
        keywordClick(foundKeywords.current.name);
        setSearchKeyword("");
      } else if (listType === "brands" && foundBrands.current.count === 1) {
        foundBrands.current.count = 0;
        brandClick(foundBrands.current.name);
        setSearchBrand("");
      } else if (listType === "interests" && foundTopics.current.count === 1) {
        foundTopics.current.count = 0;
        topicClick(foundTopics.current.name);
        setSearchTopic("");
      } else if (listType === "cities" && influencerCities.length === 1) {
        cityClick(influencerCities[0]);
        setCitiesInputValue("");
        getinfluencerCities("");
      }
    }
  };

  const handlePasteInfluencer = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData("text/plain");

    const pastedObjects = pastedData.trim().split(/\s+/)[0];

    if (isValidUrl(pastedObjects)) {
      dispatch(setIsIncorrectProviderError(false));

      const generatedCreatorFromString =
        generateCreatorFromString(pastedObjects);

      const socialPlatformValues = socialPlatformOptions.map(
        (option) => option.value,
      );
      const socialPlatformValuesWithNewTikTokName = socialPlatformValues.map(
        (provider) => replaceOldTikTokProviderName(provider),
      );

      const foundSocialProfile = generatedCreatorFromString.socialProfiles.find(
        (socialProfile) =>
          socialPlatformValuesWithNewTikTokName.includes(
            socialProfile.socialProvider,
          ),
      );

      if (foundSocialProfile) {
        setInfluencerSocialUsername([generatedCreatorFromString.username]);
      } else {
        setInfluencerSocialUsername([pastedObjects.trim()]);
        dispatch(setIsIncorrectProviderError(true));
      }
    } else {
      setInfluencerSocialUsername([pastedObjects.trim()]);
    }
  };

  const getinfluencerCities = async (value, uniqCountries) => {
    const params = new URLSearchParams({
      searchString: value || "",
      provider: CONSTS.socialProvider.instagram,
      countries:
        uniqCountries || selectedInfluencerCountries.map((el) => el.value),
    }).toString();

    const {
      data: { content: resinfluencerCities },
    } = await axios.get(CONSTS.getinfluencerCities + params);
    setInfluencerCities(resinfluencerCities);
  };

  useEffect(() => {
    if (selectedInfluencerCountries && selectedInfluencerCountries.length > 0)
      getinfluencerCities();
    else {
      setInfluencerCities([]);
    }
    setCitiesInputValue("");
  }, [selectedInfluencerCountries]);

  useEffect(() => {
    // This setTimeout is hack to fire getPopularHashtags only once on influencer list's search tab.
    if (timerId) {
      clearTimeout(timerId);
    }

    setTimerId(setTimeout(getPopularHashtags, 500));
  }, []);

  const handleHashtagsInputValueChange = (e) => {
    const { value } = e.target;
    setHashtagsInputValue(value);

    if (timerId) {
      clearTimeout(timerId);
    }
    setTimerId(setTimeout(() => getPopularHashtags(value), 500));
  };

  const handleSearchByContentValueChange = (e) => {
    const { value } = e.target;
    setSearchByContentInputValue(value);

    if (timerId) {
      clearTimeout(timerId);
    }
    setTimerId(
      setTimeout(() => {
        getPopularHashtags(value);
      }, 500),
    );
  };

  const handleCitiesInputValueChange = (cityVal) => {
    setCitiesInputValue(cityVal);
    if (timerId) {
      clearTimeout(timerId);
    }
    setTimerId(setTimeout(() => getinfluencerCities(cityVal), 500));
  };

  const clearSecondColumn = () => {
    setSearchContents([]);
    setSearchByContentInputValue("");

    setSearchHashtags([]);
    setHashtagsInputValue("");

    setSearchMentions([]);
    setMentionsInputValue("");

    setSearchBioKeywords([]);
    setBioInputValue("");

    setChosenKeywords([]);
    setSearchKeyword("");
  };

  useEffect(() => {
    if (!hasInfluencerSocialUsername && isIncorrectProviderError) {
      dispatch(setIsIncorrectProviderError(false));
    }
  }, [hasInfluencerSocialUsername, isIncorrectProviderError, dispatch]);

  const emojiPickerWrapperRef = useRef();

  useOnClickOutside(emojiPickerWrapperRef, () => {
    setShowEmojiPicker(false);
  });

  useEffect(() => {
    if (hasInitializedSections.current) {
      return;
    }

    const shouldRun =
      influencerMetricsCount > 0 ||
      contentSearchCount > 0 ||
      audienceDataCount > 0;

    if (!shouldRun) {
      setShowInfluencerMetrics(true);
      return;
    }

    hasInitializedSections.current = true;

    if (influencerMetricsCount > 0) {
      setShowInfluencerMetrics(true);
      return;
    }

    if (contentSearchCount > 0) {
      setShowInfluencerMetrics(false);
      setShowSearchByContent(true);
      return;
    }

    if (audienceDataCount > 0) {
      setShowInfluencerMetrics(false);
      setShowAudienceData(true);
    }
  }, [influencerMetricsCount, contentSearchCount, audienceDataCount]);

  return (
    <>
      <div className="creator-search-filters__container audience-search">
        {/* Creator Metrics */}
        <Accordion
          title={
            <IDHFormattedMessage
              id="front_influencer_metrics"
              defaultMessage="Creator Metrics"
            />
          }
          amount={influencerMetricsCount}
          open={showInfluencerMetrics}
          onToggle={() => {
            setShowInfluencerMetrics((prev) => {
              if (!prev) {
                setShowSearchByContent(false);
                setShowAudienceData(false);
              }
              return !prev;
            });
          }}
          headerClassName="creator-search-filters__accordion--border-top"
        >
          <section className="creator-search-filters__section">
            <SearchByUsernameOrLink
              isError={isIncorrectProviderError}
              usernames={influencerSocialUsername}
              onAddUsername={(username) =>
                setInfluencerSocialUsername((prev) => [...prev, username])
              }
              onRemoveUsername={(username) =>
                setInfluencerSocialUsername((prev) =>
                  prev.filter((u) => u !== username),
                )
              }
              onClearUsernames={() => setInfluencerSocialUsername([])}
              onUsernamePaste={handlePasteInfluencer}
            />

            {enabledSocialProviders.length > 0 && (
              <SocialPlatformTags
                selectedPlatformValues={selectedProviders}
                setSelectedPlatformValues={setSelectedProviders}
                hiddenPlatforms={hiddenSocialPlatforms}
                isExpandable
              >
                <div className="creator-search-filters__criteria-option-selector">
                  <CriteriaOptionSelector
                    value={socialPlatformOption?.value}
                    setValue={setSocialPlatformOption}
                    className="social-platform-criteria-option-selector"
                  />
                </div>
              </SocialPlatformTags>
            )}

            <FollowersRange
              influencerFollowers={influencerFollowers}
              setInfluencerFollowers={setInfluencerFollowers}
              influencerSocialUsername={influencerSocialUsername}
              isExpandableRangeTags
            />

            <InfluencerGenderSelect
              selectedInfluencerGender={influencerGender}
              onChangeInfluencerGender={setInfluencerGender}
              isDisabled={hasInfluencerSocialUsername}
            />

            <InfluencerAgeRangeSelect
              influencerAgeFrom={influencerAgeFrom}
              influencerAgeTo={influencerAgeTo}
              onChangeInfluencerAgeFrom={setInfluencerAgeFrom}
              onChangeInfluencerAgeTo={setInfluencerAgeTo}
              isDisabled={hasInfluencerSocialUsername}
            />

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_influencer_country"
            >
              <InfluencerCountryInput
                countryInputValue={countriesInputValue}
                onCountryInputValueChange={(e) =>
                  setCountriesInputValue(e.target.value)
                }
                isDisabled={hasInfluencerSocialUsername}
              />

              <InfluencerCountriesTags
                influencerCountriesByProvider={influencerCountriesByProvider}
                influencerSocialProvider={influencerSocialProvider}
                influencerCountriesForSelectedProviders={
                  influencerCountriesForSelectedProviders
                }
                countryInputValue={countriesInputValue}
                selectedInfluencerCountries={selectedInfluencerCountries}
                setInfluencerCountry={countrySet}
                unsetInfluencerCountry={countryUnset}
                clearInfluencerCountries={() =>
                  setSelectedInfluencerCountries([])
                }
                isDisabled={hasInfluencerSocialUsername}
                isExpandable
              />
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_influencer_city"
            >
              <InfluencerCityInput
                selectedInfluencerCountries={selectedInfluencerCountries}
                isDisabled={
                  !selectedInfluencerCountries.length > 0 ||
                  influencerSocialUsername.length
                }
                cityValueInput={citiesInputValue}
                onCityValueInputChange={(e) =>
                  handleCitiesInputValueChange(e.target.value)
                }
                onKeyPress={(e) => handleEnterPress(e, "cities")}
              />
              <div className="audience-search__field">
                <SelectTags
                  feed={influencerCities}
                  values={selectedInfluencerCities}
                  setValue={cityClick}
                  unsetValue={cityClick}
                  clearValues={() => setSelectedInfluencerCities([])}
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />
              </div>
            </div>

            <InfluencerCategory
              unifiedCategories={unifiedCategories}
              chosenUnifiedCategories={chosenUnifiedCategories}
              unifiedCategoryClick={unifiedCategoryClick}
              setChosenUnifiedCategories={setChosenUnifiedCategories}
              hasInfluencerSocialUsername={hasInfluencerSocialUsername}
              handleEnterPress={handleEnterPress}
            />

            <div className="audience-search__field" data-qa="filter_minimum_er">
              <div className="idh-label idh-label--with-tooltip">
                <IDHFormattedMessage
                  id="front_minimum_er"
                  defaultMessage="Minimum ER"
                />
                <MaterialTooltip
                  id="front_minimum_er_tooltip"
                  content={
                    <IDHFormattedMessage
                      id="front_minimum_er_tooltip"
                      defaultMessage="Discover creators by their ER (engagement rate). Select its minimal value. Avg. ER is average likes of their recent posts divided by their followers."
                    />
                  }
                />
              </div>
              <CustomSelect
                placeholder={intl.formatMessage({
                  id: "front_select_minimum_er",
                  defaultMessage: "Select",
                })}
                isClearable
                value={minimumEr}
                options={getMinimumErOptions()}
                onChange={(newValue) => setMinimumEr(newValue)}
                disabled={hasInfluencerSocialUsername}
                dataAttr="min-er"
              />
            </div>
            <FollowersCountRange
              influencerSocialUsername={influencerSocialUsername}
              paidPostPerformanceMin={paidPostPerformanceMin}
              setPaidPostPerformanceMin={setPaidPostPerformanceMin}
              audienceCredibilityScore={audienceCredibilityScore}
              setAudienceCredibilityScore={setAudienceCredibilityScore}
              influencerSocialProvider={influencerSocialProvider}
            />

            <CreatorTagsFilter
              creatorTags={creatorTags}
              selectedCreatorTags={selectedCreatorTags}
              setSelectedCreatorTags={setSelectedCreatorTags}
              creatorTagsOption={creatorTagsMatchType}
              setCreatorTagsOption={setCreatorTagsMatchType}
              disabled={hasInfluencerSocialUsername}
            />
          </section>

          <section className="creator-search-filters__section">
            <div
              className="creator-search-filters__show-creators"
              data-qa="filter_creators_available_in_crm"
            >
              <IDHFormattedMessage
                id="front_show_creators"
                defaultMessage="Show creators"
              />

              <PillSelector
                options={[
                  {
                    label: (
                      <IDHFormattedMessage
                        id="front_all"
                        defaultMessage="All"
                      />
                    ),
                    value: null,
                  },
                  {
                    label: (
                      <IDHFormattedMessage
                        id="front_available_in_crm"
                        defaultMessage="Available in CRM"
                      />
                    ),
                    value: "include",
                  },
                  {
                    label: (
                      <IDHFormattedMessage
                        id="front_not_available_in_crm"
                        defaultMessage="Not available in CRM"
                      />
                    ),
                    value: "exclude",
                  },
                ]}
                value={creatorsAvailableInCrm}
                onChange={setCreatorsAvailableInCrm}
                disabled={hasInfluencerSocialUsername}
              />
            </div>

            <CustomCheckbox
              id="show-only-creators-with-contact-data-checkbox"
              className="creator-search-filters__show-results-with-contact-data"
              checked={hasContactData}
              onChange={() => {
                const newValue = !hasContactData;
                setHasContactData(newValue);
              }}
              label={
                <IDHFormattedMessage
                  id="front_show_only_results_with_contact_data"
                  defaultMessage="Show only results with contact data"
                />
              }
              disabled={hasInfluencerSocialUsername}
            />
          </section>
        </Accordion>

        {/* Content Search */}
        <Accordion
          title={
            <IDHFormattedMessage
              id="front_search_by_content"
              defaultMessage="Content Search"
            />
          }
          amount={contentSearchCount}
          open={showSearchByContent}
          onToggle={() => {
            setShowSearchByContent((prev) => {
              if (!prev) {
                setShowInfluencerMetrics(false);
                setShowAudienceData(false);
              }
              return !prev;
            });
          }}
          metricsCount={contentSearchCount}
          headerClassName={{
            "creator-search-filters__accordion--border-top":
              showInfluencerMetrics,
          }}
        >
          <section className="creator-search-filters__section">
            <div className="audience-search__switch">
              <CustomSwitch
                checked={advancedSearch}
                onChange={() => {
                  setAdvancedSearch((v) => !v);
                  clearSecondColumn();
                }}
                dataAttributes={{
                  "data-qa": "advanced-search-switch",
                }}
              />
              <span>
                <div className="audience-search__switch-text">
                  <IDHFormattedMessage
                    id="front_advanced_search"
                    defaultMessage="Advanced Search"
                  />
                </div>
                <div className="audience-search__switch-subtext">
                  <IDHFormattedMessage
                    id="front_allows_you_to_search_by_specific_attributes_separately"
                    defaultMessage="Allows you to search by specific attributes separately."
                  />
                </div>
              </span>
            </div>

            {!advancedSearch && (
              <div
                className="creator-search-filters__content-wrapper"
                data-qa="filter_content_keywords"
              >
                <div className="audience-search__input">
                  <div className="idh-label">
                    <IDHFormattedMessage
                      id="front_discover_influencers_who"
                      defaultMessage="Discover influencers who"
                    />
                    :
                    <ul>
                      <li>
                        <IDHFormattedMessage
                          id="front_use_specific_hashtags"
                          defaultMessage="use specific hashtags in their posts"
                        />
                      </li>
                      <li>
                        <IDHFormattedMessage
                          id="front_mention_specific_accounts_including_brands"
                          defaultMessage="mention specific accounts (including brands that have been tagged) in their posts"
                        />
                      </li>
                      <li>
                        <IDHFormattedMessage
                          id="front_based_on_specific_physical_objects"
                          defaultMessage="based on specific physical objects that can be seen in their posts (i.e. baby, garden)"
                        />
                      </li>
                      <li>
                        <IDHFormattedMessage
                          id="front_have_specific_keywords_in_their_bio"
                          defaultMessage="have specific keywords in their Bio"
                        />
                      </li>
                    </ul>
                  </div>

                  <div className="audience-search__input-wrapper">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_enter_keywords_or_hashtags",
                        defaultMessage: "Enter keywords or hashtags",
                      })}
                      value={searchByContentInputValue}
                      onChange={handleSearchByContentValueChange}
                      onBlur={(e) => addHashtagOrBio(e, "blur", "content")}
                      onKeyUp={(e) => addHashtagOrBio(e, "keyup", "content")}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="search-by-content"
                    />

                    <CriteriaOptionSelector
                      value={contentsOption?.value}
                      setValue={setContentsOption}
                    />
                  </div>
                </div>

                <SelectTags
                  feed={popularHashtags}
                  values={searchContents}
                  setValue={contentClick}
                  unsetValue={contentClick}
                  clearValues={clearSecondColumn}
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />
              </div>
            )}

            {advancedSearch && (
              <>
                <div className="audience-search__input" data-qa="filter_hashtags">
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_hashtag_topic"
                      defaultMessage="Hashtags"
                    />
                    <MaterialTooltip
                      id="front_hashtags_topic_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_hashtags_topic_tooltip"
                          defaultMessage="Here you can specify what hashtags should most often be added to the caption of the content published by the Influencers you are looking for. Search results will return only those accounts that have those hashtags found in the captions."
                        />
                      }
                    />
                  </div>

                  <div className="audience-search__input-wrapper">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_enter_hashtags_placeholder",
                        defaultMessage: "Enter hashtags separate by comas",
                      })}
                      value={hashtagsInputValue}
                      onChange={handleHashtagsInputValueChange}
                      onBlur={(e) => addHashtagOrBio(e, "blur", "hashtag")}
                      onKeyUp={(e) => addHashtagOrBio(e, "keyup", "hashtag")}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="hashtags"
                    />

                    <CriteriaOptionSelector
                      value={hashtagsOption?.value}
                      setValue={setHashtagsOption}
                    />
                  </div>
                </div>

                <SelectTags
                  feed={popularHashtags}
                  values={searchHashtags}
                  setValue={hashtagClick}
                  unsetValue={hashtagClick}
                  clearValues={() => setSearchHashtags([])}
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />

                <div className="audience-search__input" data-qa="filter_mentions">
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_mentions"
                      defaultMessage="Mentions"
                    />
                    <MaterialTooltip
                      id="front_mentions_topic_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_mentions_topic_tooltip"
                          defaultMessage="Here you can specify what mentions should..."
                        />
                      }
                    />
                  </div>

                  <div className="audience-search__input-wrapper">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_enter_mentions_placeholder",
                        defaultMessage: "Enter mentions separated by comas",
                      })}
                      value={mentionsInputValue}
                      onChange={(e) => setMentionsInputValue(e.target.value)}
                      onKeyUp={(e) => addHashtagOrBio(e, "keyup", "mention")}
                      onBlur={(e) => {
                        addHashtagOrBio(e, "blur", "mention");
                      }}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="mention"
                    />

                    <CriteriaOptionSelector
                      value={mentionsOption?.value}
                      setValue={setMentionsOption}
                    />
                  </div>
                </div>

                {searchMentions.length > 0 && (
                  <SelectedLabels
                    values={searchMentions}
                    unsetValue={(name) => mentionClick(name)}
                    clearValues={() => setSearchMentions([])}
                    disabled={hasInfluencerSocialUsername}
                  />
                )}

                <div
                  className="audience-search__input"
                  data-qa="filter_search_in_bio"
                >
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_search_in_bio_topic"
                      defaultMessage="Search in Bio"
                    />
                    <MaterialTooltip
                      id="front_search_in_bio_topic_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_search_in_bio_topic_tooltip"
                          defaultMessage="Find Creators with specific keywords used in Bio sections."
                        />
                      }
                    />
                  </div>

                  <div className="audience-search__input-wrapper audience-search__input-wrapper--with-emoji">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_enter_keywords_placeholder",
                        defaultMessage: "Enter keywords",
                      })}
                      value={bioInputValue}
                      onChange={(e) => setBioInputValue(e.target.value)}
                      onFocus={() => setBioInputFocused(true)}
                      onKeyUp={(e) => addHashtagOrBio(e, "keyup", "bio")}
                      onBlur={(e) => {
                        addHashtagOrBio(e, "blur", "bio");
                        setBioInputFocused(false);
                      }}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="bio"
                      className={
                        showEmojiPicker && "bio-input-with-emoji-picker"
                      }
                    />

                    <div
                      className={classNames("emoji-button", {
                        "emoji-button--active":
                          bioInputFocused || showEmojiPicker,
                      })}
                    >
                      <div
                        onClick={() => {
                          setShowEmojiPicker((prev) => !prev);
                        }}
                      >
                        <Emoji unified="1f642" size="20" />
                      </div>
                    </div>

                    {showEmojiPicker && (
                      <div
                        className="emoji-picker-wrapper"
                        ref={emojiPickerWrapperRef}
                      >
                        <EmojiPicker
                          onEmojiClick={(emojiData) => {
                            addEmojiToBio(emojiData.emoji);
                            setShowEmojiPicker(false);
                          }}
                          previewConfig={{
                            defaultEmoji: "1f446",
                            defaultCaption: "Pick an emoji...",
                            showPreview: true,
                          }}
                        />
                      </div>
                    )}

                    <CriteriaOptionSelector
                      value={searchBioKeywordsOption?.value}
                      setValue={setSearchBioKeywordsOption}
                    />
                  </div>
                </div>

                {searchBioKeywords.length > 0 && (
                  <SelectedLabels
                    values={searchBioKeywords}
                    unsetValue={(index) => deleteLabel(index, "bio")}
                    clearValues={() => setSearchBioKeywords([])}
                    disabled={hasInfluencerSocialUsername}
                  />
                )}

                <div
                  className="audience-search__input"
                  data-qa="filter_ai_keywords"
                >
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_ai_image_recognition"
                      defaultMessage="AI image recognition"
                    />
                    <MaterialTooltip
                      id="front_keywords_topic_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_keywords_topic_tooltip"
                          defaultMessage="Here you can define the keywords that will best describe the content published by the influencers you are looking for. Every piece of content published by Influencers present in our database are tagged with keywords automatically based on image recognition."
                        />
                      }
                    />
                  </div>

                  <div className="audience-search__input-wrapper">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_keywords_topic_placeholder",
                        defaultMessage: "Search keywords...",
                      })}
                      value={searchKeyword}
                      onKeyPress={(e) => handleEnterPress(e, "keywords")}
                      onChange={(e) => {
                        setSearchKeyword(
                          e.target.value.charAt(0) === "#"
                            ? e.target.value.slice(1)
                            : e.target.value,
                        );
                        foundKeywords.current.count = 0;
                      }}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="keywords"
                    />

                    <CriteriaOptionSelector
                      value={aiTagsOption?.value}
                      setValue={setAiTagsOption}
                    />
                  </div>
                </div>

                <SelectTags
                  feed={keywords?.filter((keyword) =>
                    METHODS.doesTextIncludeSearchTerm(keyword, searchKeyword),
                  )}
                  values={chosenKeywords}
                  setValue={(item) => {
                    keywordClick(item);
                    foundKeywords.current.count = 0;
                  }}
                  unsetValue={(item) => {
                    keywordClick(item);
                    foundKeywords.current.count = 0;
                  }}
                  clearValues={() => setChosenKeywords([])}
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />
              </>
            )}

            <div
              className="audience-search__field"
              data-qa="filter_last_posts_within"
            >
              <div className="idh-label">
                <IDHFormattedMessage
                  id="front_last_posts_within"
                  defaultMessage="Last post within"
                />
              </div>
              <CustomSelect
                placeholder={intl.formatMessage({
                  id: "front_select",
                  defaultMessage: "Select",
                })}
                isClearable
                value={lastPostsWithin}
                options={getLastPostsWithinOptions()}
                onChange={(newValue) => setLastPostsWithin(newValue)}
                disabled={hasInfluencerSocialUsername}
                dataAttr="last-posts-within"
              />
            </div>
          </section>
        </Accordion>

        {/* Audience Data */}
        <Accordion
          title={
            <IDHFormattedMessage
              id="front_audience_data"
              defaultMessage="Audience Data"
            />
          }
          amount={audienceDataCount}
          open={showAudienceData}
          onToggle={() => {
            setShowAudienceData((prev) => {
              if (!prev) {
                setShowInfluencerMetrics(false);
                setShowSearchByContent(false);
              }
              return !prev;
            });
          }}
          headerClassName={{
            "creator-search-filters__accordion--border-top":
              showSearchByContent,
            "creator-search-filters__accordion--no-border":
              showSearchByContent || showInfluencerMetrics,
          }}
        >
          <section className="creator-search-filters__section">
            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_country"
            >
              <div className="audience-search__field">
                <div className="audience-search__input">
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_audience_country"
                      defaultMessage="Audience country"
                    />
                    <MaterialTooltip
                      id="front_audience_country_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_audience_country_tooltip"
                          defaultMessage="Discover the best influencers by countries their followers reside."
                        />
                      }
                    />
                  </div>
                  <input
                    placeholder={intl.formatMessage({
                      id: "front_search_country_placeholder",
                      defaultMessage: "Search country...",
                    })}
                    value={searchAudienceCountry}
                    onChange={(e) => setSearchAudienceCountry(e.target.value)}
                    disabled={hasInfluencerSocialUsername}
                    data-cdt-input="audience-country"
                  />
                </div>
              </div>

              <div className="audience-search__input">
                <SelectTags
                  feed={audienceCountries.filter((country) =>
                    METHODS.doesTextIncludeSearchTerm(
                      country.label,
                      searchAudienceCountry,
                    ),
                  )}
                  values={selectedAudienceCountries}
                  setValue={audienceCountrySet}
                  unsetValue={audienceCountryUnset}
                  clearValues={() => setSelectedAudienceCountries([])}
                  selectDensity
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />
              </div>
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_language"
            >
              <div className="audience-search__field">
                <div className="audience-search__input">
                  <div className="idh-label idh-label--with-tooltip">
                    <IDHFormattedMessage
                      id="front_audience_language"
                      defaultMessage="Audience language"
                    />
                    <MaterialTooltip
                      id="front_audience_language_tooltip"
                      content={
                        <IDHFormattedMessage
                          id="front_audience_language_tooltip"
                          defaultMessage="Discover the best influencers by languages their followers speak."
                        />
                      }
                    />
                  </div>
                  <input
                    placeholder={intl.formatMessage({
                      id: "front_search_language_placeholder",
                      defaultMessage: "Search language...",
                    })}
                    value={searchAudienceLanguage}
                    onChange={(e) =>
                      setSearchAudienceLanguage(e.target.value)
                    }
                    disabled={hasInfluencerSocialUsername}
                    data-cdt-input="audience-language"
                  />
                </div>
              </div>

              <div className="audience-search__input">
                <SelectTags
                  feed={audienceLanguages.filter((language) =>
                    METHODS.doesTextIncludeSearchTerm(
                      language.label,
                      searchAudienceLanguage,
                    ),
                  )}
                  values={selectedAudienceLanguages}
                  setValue={audienceLanguageSet}
                  unsetValue={audienceLanguageUnset}
                  clearValues={() => setSelectedAudienceLanguages([])}
                  selectDensity
                  disabled={hasInfluencerSocialUsername}
                  isExpandable
                />
              </div>
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_gender"
            >
              <AudienceGenderSelect
                selectedAudienceGender={audienceGender}
                onChangeAudienceGender={setAudienceGender}
                isDisabled={hasInfluencerSocialUsername}
              />

              {audienceGender && (
                <AudienceGenderDensity
                  selectedAudienceGenderDensity={audienceGenderDensity}
                  onChangeAudienceGenderDensity={setAudienceGenderDensity}
                  isDisabled={hasInfluencerSocialUsername}
                />
              )}
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_age"
            >
              <div className="audience-search__field">
                <div className="audience-search__field-columns">
                  <div className="audience-search__field-col-1">
                    <div className="idh-label idh-label--with-tooltip">
                      <IDHFormattedMessage
                        id="front_age"
                        defaultMessage="Audience age from"
                      />
                      <MaterialTooltip
                        id="front_age_tooltip"
                        content={
                          <IDHFormattedMessage
                            id="front_age_tooltip"
                            defaultMessage="Discover best influencers by their audience age. Select min. and max. age and % density for this age group among influencers."
                          />
                        }
                      />
                    </div>
                    <CustomSelect
                      placeholder={intl.formatMessage({
                        id: "front_select_age_from",
                        defaultMessage: "Select",
                      })}
                      isClearable
                      value={audienceAgeFrom}
                      options={getAges("from", audienceAgeTo)}
                      onChange={(newValue) => setAudienceAgeFrom(newValue)}
                      isDisabled={hasInfluencerSocialUsername}
                      dataAttr="audience-age-from"
                    />
                  </div>
                  <div className="audience-search__field-col-1">
                    <div className="idh-label">
                      <IDHFormattedMessage id="front_to" defaultMessage="To" />
                    </div>
                    <CustomSelect
                      placeholder={intl.formatMessage({
                        id: "front_select_age_to",
                        defaultMessage: "Select",
                      })}
                      isClearable
                      value={audienceAgeTo}
                      options={getAges("to", audienceAgeFrom)}
                      onChange={(newValue) => setAudienceAgeTo(newValue)}
                      isDisabled={hasInfluencerSocialUsername}
                      dataAttr="audience-age-to"
                    />
                  </div>
                </div>
              </div>

              {(audienceAgeFrom?.value || audienceAgeTo?.value) && (
                <AudienceAgeDensitySelect
                  selectedAudienceAgeDensity={audienceAgeDensity}
                  onChangeAudienceAgeDensity={setAudienceAgeDensity}
                  isDisabled={hasInfluencerSocialUsername}
                />
              )}
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_interests"
            >
              <AudienceInterestsInput
                searchTopicInputValue={searchTopic}
                onChangeSearchTopicInputValue={(e) => {
                  setSearchTopic(e.target.value);
                  foundTopics.current.count = 0;
                }}
                onKeyPress={(e) => handleEnterPress(e, "interests")}
                isDisabled={hasInfluencerSocialUsername}
              >
                <CriteriaOptionSelector
                  value={audienceInterestsOption?.value}
                  setValue={setAudienceInterestsOption}
                />
              </AudienceInterestsInput>
              <SelectTags
                feed={interests.filter((item) =>
                  METHODS.doesTextIncludeSearchTerm(
                    intl.formatMessage({
                      id: item.name,
                      defaultMessage: item.value,
                    }),
                    searchTopic,
                  ),
                )}
                values={chosenTopics}
                setValue={(item) => {
                  foundTopics.current.count = 0;
                  topicClick(item.value);
                  setSearchTopic("");
                }}
                unsetValue={(item) => {
                  foundTopics.current.count = 0;
                  topicClick(item);
                  setSearchTopic("");
                }}
                clearValues={() => setChosenTopics([])}
                translative
                getFullObject={(subTag) =>
                  METHODS.findObjBySubTag(subTag, interests)
                }
                disabled={hasInfluencerSocialUsername}
                isExpandable
              />
            </div>

            <div
              className="creator-search-filters__content-wrapper"
              data-qa="filter_audience_brand_affinity"
            >
              <div className="audience-search__field">
                <div className="audience-search__input">
                  <div className="idh-label">
                    <IDHFormattedMessage
                      id="front_audience_brand_affinity"
                      defaultMessage="Audience brand affinity"
                    />
                  </div>
                  <div className="audience-search__input-wrapper">
                    <input
                      placeholder={intl.formatMessage({
                        id: "front_search_brand_placeholder",
                        defaultMessage: "Search brand...",
                      })}
                      value={searchBrand}
                      onKeyPress={(e) => handleEnterPress(e, "brands")}
                      onChange={(e) => {
                        setSearchBrand(e.target.value);
                        foundBrands.current.count = 0;
                      }}
                      disabled={hasInfluencerSocialUsername}
                      data-cdt-input="audience-brand-affinity"
                    />
                    <CriteriaOptionSelector
                      value={audienceBrandAffinityOption?.value}
                      setValue={setAudienceBrandAffinityOption}
                    />
                  </div>
                </div>
              </div>
              <SelectTags
                feed={audienceBrandAffinity.filter((item) =>
                  METHODS.doesTextIncludeSearchTerm(item, searchBrand),
                )}
                values={chosenBrands}
                setValue={(item) => {
                  foundBrands.current.count = 0;
                  brandClick(item);
                  setSearchBrand("");
                }}
                unsetValue={(item) => {
                  foundBrands.current.count = 0;
                  brandClick(item);
                  setSearchBrand("");
                }}
                clearValues={() => setChosenBrands([])}
                disabled={hasInfluencerSocialUsername}
                isExpandable
              />
            </div>
          </section>
        </Accordion>
      </div>
      {footer && footer(clearFiltersState, handleApplyFilters)}
    </>
  );
}
